function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#707070}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ic_close",
  transform: "translate(-.039 .001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_4",
  d: "M1.068 20a1.029 1.029 0 0 1-.728-1.758L18.283.3a1.029 1.029 0 0 1 1.455 1.455L1.8 19.7a1.032 1.032 0 0 1-.728.3zm0 0",
  className: "cls-1"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_5",
  d: "M19.011 20a1.021 1.021 0 0 1-.727-.3L.34 1.756A1.029 1.029 0 0 1 1.8.3l17.938 17.943A1.029 1.029 0 0 1 19.011 20zm0 0",
  className: "cls-1"
}));

function SvgIcClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.72ea25f1.svg";
export { ForwardRef as ReactComponent };